const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x5F1cBBE0C9963c83bf046F1A53ECe316ea6E8cC8',
  busdAddress: '0x8CE7720fD183AeC96b676FD8250724b05b0d7a6F',
  lpAddress: '0x3B28be8f06aC700d15d573823c1dc9733BA97B7f'
}

export default priceContracts
